import React from 'react'

function Footer() {

    const website_language = localStorage.getItem("website_language")

  return (
    <div
        className='flex items-center justify-center
                  w-full
                  bg-[#054164]
                  text-white
                  mt-auto'
    >
        <div
            className='flex flex-col items-start lg:flex-row lg:items-start 
                      w-[80%]
                      pt-4 pb-4'
        >
            <div
                className='flex flex-col mr-10'
            >
                <p
                    className='font-semibold text-2xl'
                >
                    Contact
                </p>
                <ul className='p-0'>
                    <li
                        style={{
                            display: "flex"
                        }}
                    >
                        <div className='mr-2 font-semibold'>
                            Adress:
                        </div>
                        <div
                            className='max-w-[300px]'
                        >
                            <p>{website_language === "EN" ? "Alexandru Ioan Cuza University from Iasi," : "Universitatea Alexandru Ioan Cuza din Iaşi,"}</p>
                            <p>{website_language === "EN" ? "Department of Exact Sciences and Natural Sciences," : "Departamentul de Stiinţe Exacte și Stiințe ale Naturii,"}</p> 
                            <p>{website_language === "EN" ? "Institute of interdisciplinary researches ICI, UAIC," : "Institutul de Cercetări Interdisciplinare ICI, UAIC,"}</p> 
                            <p>{website_language === "EN" ? "Carol I Boulevard, No. 11, 700506, Iasi," : "Bulevardul Carol I, Nr. 11, 700506, Iasi,"}</p> 
                            <p>Romania</p>
                        </div>
                    </li>
                    <li
                        style={{
                            display: "flex",
                            marginTop: "16px"
                        }}
                    >
                        <div className='mr-2 font-semibold'>
                            {website_language === "EN" ? "Phone:" : "Telefon:"}
                        </div>
                        <div
                            className='max-w-[200px]'
                        >
                            0040 (0) 232.201.173
                        </div>
                    </li>
                    <li
                        style={{
                            display: "flex",
                            marginTop: "16px"
                        }}
                    >
                        <div className='mr-2 font-semibold'>
                            Fax:
                        </div>
                        <div
                            className='max-w-[200px]'
                        >
                            0040 (0) 232.201.150
                        </div>
                    </li>
                </ul>
            </div>
            <div
                className='flex flex-col mt-10 lg:mt-0'
            >
                <p
                    className='font-semibold text-2xl'
                >
                    {website_language === "EN" ? "Links" : "Link-uri"}
                </p>
                <ul
                    className='p-0'
                >
                    <li
                        style={{
                            display: "flex",
                            marginTop: "0px",
                            alignItems: "center"
                        }}
                    >
                        <div
                            className='max-w-[200px]'
                        >
                            <a
                                target={"_blank"}
                                href="www.uaic.ro"
                                className='hover:underline'
                            >
                                www.uaic.ro
                            </a>
                        </div>
                    </li>
                    <li
                        style={{
                            display: "flex",
                            marginTop: "16px",
                            marginRight: "0px"
                        }}
                    >
                        <div
                            className='max-w-[200px]'
                        >
                            <a
                                target={"_blank"}
                                href="https://ici.uaic.ro/"
                                className='hover:underline ml-auto'
                            >
                                www.ici.uaic.ro
                            </a>
                        </div>
                    </li>
                    <li
                        style={{
                            display: "flex",
                            marginTop: "16px",
                            marginRight: "0px"
                        }}
                    >
                        <div
                            className='max-w-[200px]'
                        >
                            <a
                                target={"_blank"}
                                href="https://eeris.eu/index.php?&code=550&sm=module.org.erris.app.infraPublic&ddpN=3663572691&we=14887eddc258a8197a58a662d964ddcd&wf=dGFCall&wtok=bf259275b78a0462e1504448a25d32a010206126&wtkps=NY1LDsIgFADvwr6Ery14Ca/A7yn90QJNjca725q4m8VMxmiu30VLjfY6jAVdi+ZMI9YZIT1VLTVOOKN8sAYYEMEEsYrZn6dRif4keSBXuQVvWzc9Qz9UT9eacmQXWCuQbi+PLnHWUFkJh6WhvZ8FfZ3xcdvD/zslv40Bp3zHIedYsFkWHGfI5rbZMTp0/XwB&wchk=4601b1738ef29111213c380c3f20d90222008660"
                                className='hover:underline ml-auto'
                            >
                                www.eeris.eu/.../ramtech
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
            <div
                className='flex flex-col lg:ml-auto mt-8 lg:mt-0'
            >
                <p
                    className='font-semibold text-xl text-center'
                >
                    {website_language === "EN" ? "Website developed by" : "Website creat de"} <a className='underline' href='https://www.linkedin.com/in/florin-raul-petcu22-10/' target="_blank">Petcu Florin-Raul</a>
                </p>
            </div>
        </div>
    </div>
  )
}

export default Footer